import { Route, Routes as Router } from "react-router-dom";
import "./App.css";
import routes from "./utils/routes.js";
import RootLayout from "./pages/RootLayout/RootLayout.jsx";
import RequireAuth from "./components/RequireAuth.js";
import Clients from "./pages/Client/Clients.jsx";
import Shops from "./pages/Shop/Shops.jsx";
import Subscription from "./pages/Subscription/Subscription.jsx";
import Home from "./pages/Home/Home.jsx";
import { ConfigProvider } from "antd";
import Missing from "./pages/Result/Missing.js";
import Login from "./pages/Login/Login.jsx";
import Unauthorized from "./pages/Result/Unauthorized.js";
import ErrorPage from "./pages/Result/Error.js";
import SuccessPage from "./pages/Result/Success.jsx";
import PersistLogin from "./components/PersistLogin.jsx";
import Applications from "./pages/Application/Applications.jsx";
import ApplicationStatuses from "./pages/ApplicationStatus/ApplicationStatuses.jsx";
import CreateClient from "./pages/Client/CreateClient.jsx";
import ClientDetails from "./pages/Client/ClientDetails.jsx";
import CreateShop from "./pages/Shop/CreateShop.jsx";
import ShopDetails from "./pages/Shop/ShopDetails.jsx";
import UpdateApplication from "./pages/Application/UpdateApplication.jsx";
import CreateApplication from "./pages/Application/CreateApplication.jsx";
import CreateApplicationStatus from "./pages/ApplicationStatus/CreateApplicationStatus.jsx";
import UpdateApplicationStatus from "./pages/ApplicationStatus/UpdateApplicationStatus.jsx";
import AppNotifications from "./pages/Notification/AppNotification/AppNotifications.jsx";
import UserNotifications from "./pages/Notification/UserNotification/UserNotifications.jsx";
import SendNotification from "./pages/Notification/SendNotification.jsx";
import UserNotificationDetails from "./pages/Notification/UserNotification/UserNotificationDetails.jsx";
import OtherCards from "./pages/OtherCards/OtherCards.jsx";
import UpdateOtherCard from "./pages/OtherCards/UpdateOtherCard.jsx";
import CreateOtherCard from "./pages/OtherCards/CreateOtherCard.jsx";
import OtherCardUsage from "./pages/OtherCards/OtherCardUsage.jsx";
import CardBackgroundPresets from "./pages/CardBackgroundPreset/CardBackgroundPresets.jsx";
import CreateCardBackgroundPreset from "./pages/CardBackgroundPreset/CreateCardBackgroundPreset.jsx";
import UpdateCardBackgroundPreset from "./pages/CardBackgroundPreset/UpdateCardBackgroundPreset.jsx";
import InvalidSubs from "./pages/Shop/InvalidSubs.jsx";
import Transactions from "./pages/Transaction/Transactions.jsx";
function App() {
  return (
    <div className="App">
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: "#0100A0",
            // Alias Token
            colorBgContainer: "#ffffff",
          },
        }}>
        <Router>
          <Route path={routes.login} element={<Login />} />

            <Route element={<RootLayout />}>
              {/* {Result routes} */}
              <Route path={routes.unauthorized} element={<Unauthorized />} />
              <Route path={routes.error} element={<ErrorPage />} />
              <Route path={routes.success} element={<SuccessPage />} />

              {/* {Protected Routes} */}
              <Route element={<PersistLogin />}>
                <Route
                  element={
                    <RequireAuth
                      allowedRoles={["ADMIN", "SUPER_ADMIN", "BACKOFFICE_USER"]}
                    />
                  }>
                  {/* Home */}
                  <Route path={routes.home} element={<Home />} />
                  {/* Clients */}
                  <Route path={routes.clients} element={<Clients />} />

                  <Route
                    path={routes.createClient}
                    element={<CreateClient />}
                  />
                  <Route
                    path={`${routes.clientDetails}/:clientId`}
                    element={<ClientDetails />}
                  />

                  {/* Shops */}
                  <Route path={routes.shops} element={<Shops />} />
                  <Route path={routes.invalidSubs} element={<InvalidSubs />} />
                  <Route path={routes.createShop} element={<CreateShop />} />
                  <Route
                    path={`${routes.shopDetails}/:shopId`}
                    element={<ShopDetails />}
                  />
                  {/* Subscription */}
                  <Route
                    path={routes.subscription}
                    element={<Subscription />}
                  />

                  {/* Application Status */}
                  <Route
                    path={routes.applicationStatuses}
                    element={<ApplicationStatuses />}
                  />
                  <Route
                    path={routes.createApplicationStatus}
                    element={<CreateApplicationStatus />}
                  />
                  <Route
                    path={`${routes.updateApplicationStatus}/:appStatusId`}
                    element={<UpdateApplicationStatus />}
                  />

                  {/* Application  */}
                  <Route
                    path={routes.applications}
                    element={<Applications />}
                  />
                  <Route
                    path={`${routes.updateApplication}/:appId`}
                    element={<UpdateApplication />}
                  />
                  <Route
                    path={routes.createApplication}
                    element={<CreateApplication />}
                  />

                  {/* Other Card  */}
                  <Route path={routes.otherCards} element={<OtherCards />} />
                  <Route
                    path={`${routes.updateOtherCard}/:otherCardId`}
                    element={<UpdateOtherCard />}
                  />
                  <Route
                    path={routes.createOtherCard}
                    element={<CreateOtherCard />}
                  />
                  <Route
                    path={routes.otherCardUsage}
                    element={<OtherCardUsage />}
                  />

                  {/* Card Background Presets */}
                  <Route
                    path={routes.cardBackgroundPresets}
                    element={<CardBackgroundPresets />}
                  />
                  <Route
                    path={routes.createCardBackgroundPreset}
                    element={<CreateCardBackgroundPreset />}
                  />
                  <Route
                    path={`${routes.updateCardBackgroundPreset}/:presetId`}
                    element={<UpdateCardBackgroundPreset />}
                  />

                  {/* Transactions */}
                  <Route
                    path={routes.transactions}
                    element={<Transactions />}
                  />

                  {/* Notification */}
                  <Route
                    path={routes.appNotifications}
                    element={<AppNotifications />}
                  />
                  <Route
                    path={routes.userNotifications}
                    element={<UserNotifications />}
                  />
                  <Route
                    path={`${routes.userNotificationDetails}/:userNotificationId`}
                    element={<UserNotificationDetails />}
                  />
                  <Route
                    path={routes.sendNotification}
                    element={<SendNotification />}
                  />
                </Route>
              </Route>
            </Route>

          <Route path={routes.missing} element={<Missing />} />
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
